export type PopupSide = 'top' | 'bottom' | 'left' | 'right';
export type PopupAlign = 'start' | 'center' | 'end';

/** Popper-style placement (`bottom-start`). */
export type PopupPlacement = PopupSide | `${PopupSide}-${Exclude<PopupAlign, 'center'>}`;

export type PopupPositionMethod = 'absolute' | 'fixed';

export type VirtualElement = {
  getBoundingClientRect: () => DOMRect;
};

/** `bottom-start` → Base UI `side` + `align`. */
export function popupPlacement(placement: string | undefined): { side: PopupSide; align: PopupAlign } {
  const value = placement ?? 'bottom';
  const [sideRaw, alignRaw] = value.split('-');
  const side = (['top', 'bottom', 'left', 'right'].includes(sideRaw) ? sideRaw : 'bottom') as PopupSide;
  const align = (alignRaw === 'start' || alignRaw === 'end' ? alignRaw : 'center') as PopupAlign;
  return { side, align };
}
